import { getTable as dbGetTable } from ":shared/database/get-table";
import type { TagIdentifiable } from "../model";

export const TABLE = "tags";
export const getTable = () => dbGetTable<TagIdentifiable, string>(TABLE);

export interface Filters {
	id?: string | string[];
	query?: string;
}

export const QUERY_KEYS = {
	records: (filters: Filters = {}) => [TABLE, filters],
};
